import type { C1_Room } from "./C1_Room";
import { unplacedElectricalDevicesForRoom } from "./C1_unplacedElectricalDevices";
import { c1_state } from "./C1_runtimeContext";

/** A plan click opens pending equipment instead of the room's property editor. */
export function openUnplacedRoomChapter(room: C1_Room): boolean {
  if (!["EloConcept", "EloDetail"].includes(c1_state.editMode.value) || !room.owner) return false;
  if (!unplacedElectricalDevicesForRoom(room.owner).length) return false;
  c1_state.setSelection(undefined);
  state.dockManager.closeItemEditor();
  state.dockManager.openPalette();
  c1_state.furnitureCategoryScrollRequest.value = null;
  c1_state.unplacedRoomChapterRequest.value = {
    roomId: room.id,
    requestId: (c1_state.unplacedRoomChapterRequest.value?.requestId ?? 0) + 1,
  };
  return true;
}
